import { render } from "./Contactos.vue?vue&type=template&id=307b1a7a"
import script from "./Contactos.vue?vue&type=script&lang=js"
export * from "./Contactos.vue?vue&type=script&lang=js"
script.render = render

export default script